import { render, staticRenderFns } from "./DataTransfersFlowTable.vue?vue&type=template&id=7cccdc3d"
import script from "./DataTransfersFlowTable.vue?vue&type=script&lang=js"
export * from "./DataTransfersFlowTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports